import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRiotgamesComponent } from './simple-icons-riotgames.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRiotgamesComponent ],
    exports:      [ SimpleIconsRiotgamesComponent ],
    bootstrap:    []
})
export class SimpleIconsRiotgamesModule {}
